<template>
    <section>
        <div v-if="recipients_loading">
            <Loading />
        </div>
        <div v-else>
            <profile-nav></profile-nav>
            <theme-profile></theme-profile>
            <div id="cards" class="card-container">
                <h2>{{ $t('theme_detail_page.related_recipients_title') }}</h2>
                <ul class="cards" :class="{'grid': recipients.length > 1, 'small-grid': recipients.length < 4}">
                    <recipient-card v-for="recipient in recipients" v-bind:key="recipient.irn" :model="recipient"></recipient-card>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

import Loading from '@/components/Loading'
import ProfileNav from "@/components/ProfileNav"
import RecipientCard from '@/components/RecipientCard'
import ThemeProfile from "@/components/ThemeProfile"

export default {
    components: {
        Loading,
        RecipientCard,
        ProfileNav,
        ThemeProfile
    },
    props: {
        theme: String
    },
    computed: {
        ...mapGetters({
            'item' : 'themes/item',
            'recipients': 'themes/recipients',
            'recipients_loading': 'themes/recipients_loading'
        }),
        meta_description() {
            return this.item ? this.item.description.slice(0, 100) + '...' : '';
        },
        meta_image() {
            return this.item ? this.item.image : '';
        },
        meta_title() {
            return this.item ? this.item.name : '-'
        }
    },
    head: {
        title: function() {
            return {
                inner: this.meta_title,
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.meta_description, id: 'desc'},

                {property: 'og:title', content: `${this.meta_title} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.meta_description, id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: `${window.location.host}${this.meta_image}`, id: 'og-image'}
            ]
        }
    },
    methods: {
        back: (el => {
            window.history.back()
        }),
    },
    async beforeDestroy() {
        await this.$store.dispatch("themes/null_item")
    },
    async mounted() {
        setTimeout(() => {
            document.querySelector('html').scrollTop = 0;
        }, 100);

        await this.$store.dispatch("themes/fetch_list", {
            locale: this.$i18n.locale
        })
        await this.$store.dispatch("themes/fetch_recipients", {
            locale: this.$i18n.locale,
            slug: this.$route.params.slug
        })

        this.$emit('updateHead')
    }
}
</script>

<style scoped>

</style>